import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArchivosSubidosInterface } from 'app/models/archivos-subidos-model';
import { forkJoin, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { ArchivosSubidosService } from './archivos-subidos.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UtilsService } from 'app/modules/utils-service';
import { DetalleTareaService } from 'app/modules/admin/detalle-tareas/detalle-tareas-service';
import { ComentariosService } from '../cometarios/comentarios.service';
import { MatDialog } from '@angular/material/dialog';
import { customDialogResponse, DialogDataInterface } from 'app/modules/GlobalComponents/confirm-dialog-with-notes/dialog-data.interface';
import { Tarea } from 'app/models/tareas.model';
import { ActualizarMetadataDTO } from 'app/models/actualizar-metadata.model';
import { environment as env } from 'environments/environments';
import { StatusStickerComponent } from "app/modules/GlobalComponents/status sticker.component";
import { CONSTANTS } from 'app/core/constants';

@Component({
    selector: 'archivos-subidos',
    templateUrl: 'archivos-subidos.html',
    imports: [CommonModule, MatButtonModule, MatIconModule, StatusStickerComponent, StatusStickerComponent]
})

export class ArchivosSubidosComponent {
    @Output() abrirDrawer = new EventEmitter<any>();
    @Input() tipoTarea:number
    
    archivos$ :  Observable<ArchivosSubidosInterface[]>
    tareaDetalle$:Observable<Tarea>
    tareaDetalleModificada:Tarea
    estadoRechazado:number= 1
    estadoAceptado:number= 2

    tipology_Id_Gestiones:number= env.TIPOLOGIA_ID_GESTIONES
    tipologiaIdOrigenTareaVA: number = CONSTANTS.ID_ORIGEN_TAREA_VENTANILLA_AGIL

    private destroy$ = new Subject<void>();

    constructor( 
        private archivosSubidosService: ArchivosSubidosService,
        private utilsService: UtilsService,
        private _detalleTareasService: DetalleTareaService,
        private _comentariosService: ComentariosService,
        public dialog: MatDialog,
    ) 
    {
        this.archivos$ =  this.archivosSubidosService.archivos$
    }

    ngOnInit() {
        this._detalleTareasService.detalleTarea$
        .pipe(takeUntil(this.destroy$))
        .subscribe(tarea => {
            this.tareaDetalleModificada = { ...tarea };
        });
    }

    aceptarDocumento(file: ArchivosSubidosInterface) {
        this.utilsService.open_confirm_dialog(`Esta seguro que desea Aceptar el documento  ${file.documentoEsperado ?? file.nombreArchivo}`, 'Confirmar Aceptación de Documento')
        .subscribe(response=>{
            if(response == 'confirmed'){
                const params = { 'aceptarArchivo' : true}
                
                //convertir funciones a observables
                const actualizarEstado$ = this.actualizarEstadoDocumento(file, params, 'archivo ok')  
                const actualizarMetadata$ = this.actualizarMetadata(file.archivoExternoId, this.estadoAceptado);
    
            // enviamos al API y actualizamos la lista de archivos y 
            // ejecutamos ambas operaciones en paralelo con forkJoin
            forkJoin([actualizarEstado$, actualizarMetadata$])
            }
        })

    }

    async rechazarDocumento(file: ArchivosSubidosInterface) {
        // data para configurar el modal de confirmación
        const dialogConfig: DialogDataInterface = {
            title: 'Confirmar Rechazo de Documento',
            description: `Escriba los motivos de rechazo del documento: ${file.documentoEsperado ?? file.nombreArchivo}`,
            dimissible: false,
        };
    
        //se abre el modal y esperamos la respuesta del usuario en una promesa
        const dialogResponse: customDialogResponse = await this.utilsService.openConfirDialogWithNotes(dialogConfig);
    
        // validamos que la respuesta es true para rechazar el documento
        if (dialogResponse.confirmed) {
            const params = { aceptarArchivo: false };
    
            // Convertimos las funciones en Observables
            const actualizarEstado$ = this.actualizarEstadoDocumento(file, params, dialogResponse.comentarios);
            const actualizarMetadata$ = this.actualizarMetadata(file.archivoExternoId, this.estadoRechazado, dialogResponse.comentarios);
    
            // enviamos al API y actualizamos la lista de archivos y 
            // ejecutamos ambas operaciones en paralelo con forkJoin
            forkJoin([actualizarEstado$, actualizarMetadata$])
        }
    }

    private async actualizarEstadoDocumento(file:  ArchivosSubidosInterface, params:object, razon_rechazo?: string){
       await  this.archivosSubidosService.actualizarEstadoArchivo(file.archivoId, params, razon_rechazo)
       

        // se actualizan los archivos
        // se actualiza la bitacora
        // se actualizan los comentario
        this.archivosSubidosService.getArchivosByEntity(this.utilsService.activeEntityUuid);
        // actividades Recientes
        this._detalleTareasService.getActividadesByTask(this.utilsService.activeEntityUuid)
        // comentarios
        this._comentariosService.getComentariosByEntity(this.utilsService.activeEntityUuid)

    }

    async actualizarMetadata(idDocumento: number, estado: number, comentario?: string) { 
        // Buscar el documento en el array de Documentos
        const documento = this.tareaDetalleModificada.metadata.Documentos.find(doc => doc.Id === idDocumento.toString());
    
        if (documento) {   
            documento.Estado = estado;
            documento.Comentario = comentario;

            const datosActualizados:ActualizarMetadataDTO = {
                tarea: {
                    ...this.tareaDetalleModificada
                }
            };
    
            try {
                await this._detalleTareasService.putMetadata(datosActualizados, datosActualizados.tarea.tareaUuid);
            } catch (error) {
               
            }
        }
    }

    async mostrarArchivoDrawer(file: ArchivosSubidosInterface) {
        const safeURL = file.archivoExternoId
            ? await this.utilsService.getVADocumentPreview(file.archivoId)
            : await this.utilsService.getArchivosInternos(file.archivoId);

        file.blobURL = safeURL || null;
        this.abrirDrawer.emit(file);
    }

    reenviarArchivoVA(archivo:ArchivosSubidosInterface){
        let body={
            gestionUuid: archivo.entidadUuid,
            documentoOficialId: archivo.archivoId
        }
        this.archivosSubidosService.reenviarArchivoAV(body)
        .then((response:any)=>{
            this.utilsService.openSuccessSnakBar(response.message)
        })
    }

    eliminarArchivos(archivo:ArchivosSubidosInterface){
        this.utilsService.open_confirm_dialog(
            `Está seguro que desea Eliminar el documento, ${
            archivo.documentoEsperado 
                ? archivo.documentoEsperado 
                : archivo.nombreArchivo
            }`, 
            `Eliminar Plantilla`
          )
        .subscribe(response=>{
            if (response === 'confirmed') {
                this.archivosSubidosService.eliminarArchivo(archivo.archivoId)
                .then((response) => {
                    this.utilsService.openSuccessSnakBar('Documento eliminado correctamente')
                    this.archivosSubidosService.getArchivosByEntity(this.utilsService.activeEntityUuid)
                })
            }
        })
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    
}